<section class="container pt-2">
  <div class="row">
    <div class="col-md-8 offset-lg-1 pb-5 mb-2 mb-lg-4 pt-md-5 mt-n3 mt-md-0 text-center">
      <h3>We've hit a snag</h3>
      <p>
        We are working on it, and appreciate your patience. <br />
        If you require assistance, please contact
        <a href="mailto:support@appliedbiox.com">support&#64;appliedbiox.com</a>.
      </p>
      @if (isDev && (auth.error$ | async); as err) {
        <pre class="text-start mt-3 p-3 bg-light border rounded small">{{ err.message }}<br>{{ err | json }}</pre>
      }
    </div>
  </div>
</section>
